module.exports = __webpack_public_path__ + "img/5-2.3a1336ef.svg";